import { render } from "./HistoryLog.vue?vue&type=template&id=297dc966"
import script from "./HistoryLog.vue?vue&type=script&lang=js"
export * from "./HistoryLog.vue?vue&type=script&lang=js"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__